"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1336],{

/***/ 1219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7579);
/* harmony import */ var _components_atomic_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8509);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5893);


var _excluded = ["color", "innerSpace", "notRoundedMobile", "roundingRadius"],
    _excluded2 = ["color", "roundingRadius"],
    _excluded3 = ["text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var devices = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.devices */ .r.devices,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.spaces */ .r.spaces; // eslint-disable-next-line prettier/prettier, react/display-name

var StyledContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref, ref) {
  var color = _ref.color,
      innerSpace = _ref.innerSpace,
      notRoundedMobile = _ref.notRoundedMobile,
      roundingRadius = _ref.roundingRadius,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "PriceBanner__StyledContainer",
  componentId: "sc-1kna8im-0"
})(["display:flex;justify-content:space-between;align-items:flex-start;border-radius:", "px;", " ", " ", " @media ", "{flex-direction:column;justify-content:flex-start;align-items:center;padding:", "px;", "}"], spaces.regular, function (_ref2) {
  var _color$gradient;

  var color = _ref2.color;
  return color && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["background:", ";"], color !== null && color !== void 0 && color.gradient ? (_color$gradient = color.gradient) === null || _color$gradient === void 0 ? void 0 : _color$gradient.from : color);
}, function (_ref3) {
  var innerSpace = _ref3.innerSpace;
  return innerSpace && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["padding:", "px;"], typeof innerSpace === 'number' ? innerSpace : spaces.medium);
}, function (_ref4) {
  var roundingRadius = _ref4.roundingRadius;
  return roundingRadius && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["border-radius:", "px;"], roundingRadius);
}, devices.tablet, spaces.regular, function (_ref5) {
  var notRoundedMobile = _ref5.notRoundedMobile;
  return notRoundedMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["border-radius:0;"]);
});
var StyledContent = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceBanner__StyledContent",
  componentId: "sc-1kna8im-1"
})(["@media ", "{width:100%;}"], devices.tablet);
var StyledTitle = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceBanner__StyledTitle",
  componentId: "sc-1kna8im-2"
})([""]);
var StyledBody = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceBanner__StyledBody",
  componentId: "sc-1kna8im-3"
})([""]);
var StyledFooter = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceBanner__StyledFooter",
  componentId: "sc-1kna8im-4"
})(["@media ", "{display:none;}"], devices.tablet);
var StyledFooterMobile = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceBanner__StyledFooterMobile",
  componentId: "sc-1kna8im-5"
})(["display:none;@media ", "{display:block;}"], devices.tablet); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledBadge = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref6, ref) {
  var color = _ref6.color,
      roundingRadius = _ref6.roundingRadius,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref6, _excluded2);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "PriceBanner__StyledBadge",
  componentId: "sc-1kna8im-6"
})(["display:flex;flex-direction:column;justify-content:flex-start;align-items:center;padding:", "px;border-radius:", "px;", " ", " @media ", "{width:100%;}"], spaces.regular, spaces.small - 2, function (_ref7) {
  var _color$gradient2, _color$gradient3;

  var color = _ref7.color;
  return color && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["background:", ";"], color !== null && color !== void 0 && color.gradient ? "linear-gradient(0deg, ".concat((_color$gradient2 = color.gradient) === null || _color$gradient2 === void 0 ? void 0 : _color$gradient2.from, " 0%, ").concat((_color$gradient3 = color.gradient) === null || _color$gradient3 === void 0 ? void 0 : _color$gradient3.to, " 100%)") : color);
}, function (_ref8) {
  var roundingRadius = _ref8.roundingRadius;
  return roundingRadius && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(["border-radius:", "px;"], roundingRadius);
}, devices.tablet);
var StyledBadgeText = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceBanner__StyledBadgeText",
  componentId: "sc-1kna8im-7"
})([""]);
var StyledBadgeSubtext = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceBanner__StyledBadgeSubtext",
  componentId: "sc-1kna8im-8"
})([""]);
var StyledButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "PriceBanner__StyledButtonContainer",
  componentId: "sc-1kna8im-9"
})(["margin-top:", "px;"], spaces.small);

var PriceBanner = function PriceBanner(_ref9) {
  var children = _ref9.children,
      innerSpace = _ref9.innerSpace,
      roundingRadius = _ref9.roundingRadius,
      notRoundedMobile = _ref9.notRoundedMobile,
      title = _ref9.title,
      badgeText = _ref9.badgeText,
      badgeSubtext = _ref9.badgeSubtext,
      badgeRoundingRadius = _ref9.badgeRoundingRadius,
      color = _ref9.color,
      footer = _ref9.footer,
      _ref9$buttons = _ref9.buttons,
      buttons = _ref9$buttons === void 0 ? [] : _ref9$buttons;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledContainer, {
    color: color,
    innerSpace: innerSpace,
    notRoundedMobile: notRoundedMobile,
    roundingRadius: roundingRadius,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledContent, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledTitle, {
        children: title
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledBody, {
        children: children
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledFooter, {
        children: footer
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)(StyledBadge, {
      color: color,
      roundingRadius: badgeRoundingRadius,
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledBadgeText, {
        children: badgeText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledBadgeSubtext, {
        children: badgeSubtext
      }), !!(buttons !== null && buttons !== void 0 && buttons.length) && buttons.map(function (_ref10, idx) {
        var text = _ref10.text,
            btnProps = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_ref10, _excluded3);

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledButtonContainer, {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(_components_atomic_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, btnProps), {}, {
            children: text
          }))
        }, "btn:".concat(idx));
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(StyledFooterMobile, {
      children: footer
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (PriceBanner);

/***/ }),

/***/ 317:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9499);
/* harmony import */ var _builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(4730);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5444);
/* harmony import */ var _constants_theme__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7579);
/* harmony import */ var _constants_icons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(934);
/* harmony import */ var _components_atomic_Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8509);
/* harmony import */ var _components_atomic_Icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(6668);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(5893);


var _excluded = ["hideImageMobile"],
    _excluded2 = ["hint", "text"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var colors = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.colors */ .r.colors,
    devices = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.devices */ .r.devices,
    fontSizes = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.fontSizes */ .r.fontSizes,
    spaces = _constants_theme__WEBPACK_IMPORTED_MODULE_2__/* .theme.spaces */ .r.spaces;
var StyledBanner = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBanner",
  componentId: "sc-bwckw6-0"
})(["position:relative;display:flex;flex-direction:column;align-items:center;width:100%;&::before{content:'';display:block;position:absolute;left:0;right:0;top:0;bottom:0;background:", ";border-bottom-left-radius:100px;border-bottom-right-radius:100px;z-index:-1;}@media ", "{padding-left:", "px;padding-right:", "px;&::before{border-bottom-left-radius:32px;border-bottom-right-radius:32px;}}@media ", "{&::before{border-bottom-left-radius:32px;border-bottom-right-radius:32px;}}"], colors.blue[50], devices.laptopM, spaces.large2X, spaces.large2X, devices.tablet);
var StyledBannerContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBannerContainer",
  componentId: "sc-bwckw6-1"
})(["display:flex;justify-content:space-between;position:relative;max-width:", "px;width:100%;padding-top:", "px;padding-bottom:", "px;@media ", "{padding-left:", "px;padding-right:", "px;padding-top:", "px;padding-bottom:0;}"], spaces.large24X * 10 + 80, spaces.large2X, spaces.large2X, devices.tablet, spaces.regular, spaces.regular, spaces.regular);
var StyledBannerImageContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBannerImageContainer",
  componentId: "sc-bwckw6-2"
})(["", " @media ", "{display:none;}"], function (_ref) {
  var width = _ref.width;
  return width && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(["img{width:", "px;}"], width);
}, devices.tablet); // eslint-disable-next-line prettier/prettier, react/display-name

var StyledMobileBannerImageContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)( /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function (_ref2, ref) {
  var hideImageMobile = _ref2.hideImageMobile,
      props = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref2, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("div", _objectSpread({
    ref: ref
  }, props));
})).withConfig({
  displayName: "BaseBannerSection__StyledMobileBannerImageContainer",
  componentId: "sc-bwckw6-3"
})(["display:none;text-align:center;img{width:50%;}@media ", "{display:block;margin-bottom:", "px;text-align:center;", "}"], devices.tablet, spaces.regular, function (_ref3) {
  var hideImageMobile = _ref3.hideImageMobile;
  return hideImageMobile && (0,styled_components__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)(["display:none;"]);
});
var StyledBannerContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBannerContentContainer",
  componentId: "sc-bwckw6-4"
})(["display:flex;flex-direction:column;justify-content:center;padding-right:12%;@media ", "{padding-right:0;}"], devices.tablet);
var StyledBannerTitle = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBannerTitle",
  componentId: "sc-bwckw6-5"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:500;color:", ";@media ", "{text-align:center;font-size:", "px;text-align:center;}"], spaces.regular, fontSizes.large8X, colors.gray[800], devices.tablet, fontSizes.large2X);
var StyledBannerText = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBannerText",
  componentId: "sc-bwckw6-6"
})(["margin-bottom:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";a{color:", ";}@media ", "{display:none;text-align:center;font-size:", "px;text-align:center;}"], spaces.regular, fontSizes.large, colors.gray[700], colors.blue[500], devices.tablet, fontSizes.regular);
var StyledBulletsContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBulletsContainer",
  componentId: "sc-bwckw6-7"
})(["margin-bottom:", "px;"], spaces.largeX + 2);
var StyledBullet = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBullet",
  componentId: "sc-bwckw6-8"
})(["display:flex;align-items:center;margin-bottom:", "px;"], spaces.small - 2);
var StyledBulletIconContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBulletIconContainer",
  componentId: "sc-bwckw6-9"
})(["margin-right:", "px;"], spaces.small);
var StyledBulletText = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledBulletText",
  componentId: "sc-bwckw6-10"
})(["flex-grow:1;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";@media ", "{font-size:", "px;}"], fontSizes.large, colors.gray[700], devices.tablet, fontSizes.regular);
var StyledButtonsContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledButtonsContainer",
  componentId: "sc-bwckw6-11"
})(["display:flex;justify-content:flex-start;flex-wrap:wrap;@media ", "{justify-content:center;}"], devices.tablet);
var StyledButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledButtonContainer",
  componentId: "sc-bwckw6-12"
})(["margin-right:", "px;margin-bottom:", "px;&:last-child{margin-right:0;}@media ", "{margin-right:", "px;}"], spaces.regular, spaces.regular, devices.tablet, spaces.small);
var StyledButtonHint = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "BaseBannerSection__StyledButtonHint",
  componentId: "sc-bwckw6-13"
})(["margin-top:", "px;font-family:'Aeonik';font-style:normal;font-size:", "px;font-weight:400;color:", ";text-align:center;"], spaces.small2X, fontSizes.smallX, colors.gray[500]);

var BaseBannerSection = function BaseBannerSection(_ref4) {
  var hideImageMobile = _ref4.hideImageMobile,
      imgSrc = _ref4.imgSrc,
      title = _ref4.title,
      text = _ref4.text,
      bullets = _ref4.bullets,
      defaultBulletIcon = _ref4.defaultBulletIcon,
      buttons = _ref4.buttons;
  var isBullets = Boolean(bullets === null || bullets === void 0 ? void 0 : bullets.length);
  var isButtons = Boolean(buttons === null || buttons === void 0 ? void 0 : buttons.length);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBanner, {
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledBannerContainer, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledBannerContentContainer, {
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBannerTitle, {
          children: title
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBannerText, {
          children: text
        }), isBullets && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBulletsContainer, {
          children: bullets.map(function (bullet, idx) {
            var icon = bullet.icon,
                text = bullet.text;

            if (text) {
              return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledBullet, {
                children: [icon && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBulletIconContainer, {
                  children: icon
                }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBulletText, {
                  children: text
                })]
              }, "bullet:".concat(idx));
            }

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledBullet, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBulletIconContainer, {
                children: defaultBulletIcon || /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_atomic_Icon__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                  alias: _constants_icons__WEBPACK_IMPORTED_MODULE_3__/* .ICONS_ALIASES.checkRounded */ .F.checkRounded,
                  color: colors.blue[500]
                })
              }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBulletText, {
                children: bullet
              })]
            }, "bullet:".concat(idx));
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledMobileBannerImageContainer, {
          hideImageMobile: hideImageMobile,
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("picture", {
            children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("source", {
              srcSet: imgSrc,
              type: "image/svg"
            }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
              src: imgSrc,
              alt: "Banner image"
            })]
          })
        }), isButtons && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledButtonsContainer, {
          children: buttons.map(function (_ref5, idx) {
            var hint = _ref5.hint,
                text = _ref5.text,
                restButtonProps = (0,_builds_innova_labs_developers_trademark_trademark_frontend_v2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_ref5, _excluded2);

            return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)(StyledButtonContainer, {
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(_components_atomic_Button__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, restButtonProps), {}, {
                children: text
              })), hint && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledButtonHint, {
                children: hint
              })]
            }, "button:".concat(idx));
          })
        })]
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)(StyledBannerImageContainer, {
        width: !isBullets && !isButtons ? 230 : undefined,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsxs)("picture", {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("source", {
            srcSet: imgSrc,
            type: "image/png"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__.jsx)("img", {
            src: imgSrc,
            alt: "Banner image"
          })]
        })
      })]
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (BaseBannerSection);

/***/ }),

/***/ 6058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EX": function() { return /* binding */ selectPricesLoading; },
/* harmony export */   "Ej": function() { return /* binding */ selectPriceMapByProcessingCode; },
/* harmony export */   "MG": function() { return /* binding */ selectProcessingOptionsLoading; },
/* harmony export */   "SA": function() { return /* binding */ selectAvailableUpsellProductCodes; },
/* harmony export */   "Tu": function() { return /* binding */ selectFileTypesLoading; },
/* harmony export */   "bi": function() { return /* binding */ selectUpsellOffersLoading; },
/* harmony export */   "f4": function() { return /* binding */ selectPriceMapByProductCode; },
/* harmony export */   "q_": function() { return /* binding */ selectProcessingCodes; },
/* harmony export */   "rq": function() { return /* binding */ selectFileTypes; }
/* harmony export */ });
/* unused harmony exports selectStates, selectStatesError, selectStatesLoading, selectStateOptions, selectProcessingOptions, selectProcessingOptionsError, selectPrices, selectPricesError, selectRushProcessingPriceByProcessingCode, selectFees, selectFeesError, selectFeesLoading, selectFeeMapByProductCode, selectFeeMapByProcessingCode, selectUpsellOffers, selectUpsellOffersError, selectFileTypesError */
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8697);
/* harmony import */ var _constants_products__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3193);


var selectStates = function selectStates(state) {
  return state.variants.states.data;
};
var selectStatesError = function selectStatesError(state) {
  return state.variants.states.error;
};
var selectStatesLoading = function selectStatesLoading(state) {
  return state.variants.states.loading;
};
var selectStateOptions = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([selectStates], function (states) {
  return states.map(function (_ref) {
    var code = _ref.code,
        name = _ref.name;
    return {
      title: name,
      value: code
    };
  });
});
var selectProcessingOptions = function selectProcessingOptions(state) {
  return state.variants.processingOptions.data;
};
var selectProcessingOptionsError = function selectProcessingOptionsError(state) {
  return state.variants.processingOptions.error;
};
var selectProcessingOptionsLoading = function selectProcessingOptionsLoading(state) {
  return state.variants.processingOptions.loading;
};
var selectProcessingCodes = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([selectProcessingOptions], function (processingOptions) {
  return processingOptions.map(function (_ref2) {
    var code = _ref2.code;
    return code;
  });
});
var selectPrices = function selectPrices(state) {
  return state.variants.prices.data;
};
var selectPricesError = function selectPricesError(state) {
  return state.variants.prices.error;
};
var selectPricesLoading = function selectPricesLoading(state) {
  return state.variants.prices.loading;
};
var selectPriceMapByProductCode = function selectPriceMapByProductCode(productCode) {
  return (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([selectPrices], function (prices) {
    return prices.filter(function (_ref3) {
      var code = _ref3.code.code;
      return code === productCode;
    }).reduce(function (res, _ref4) {
      var option = _ref4.option,
          price = _ref4.price;
      res[option] = price;
      return res;
    }, {});
  });
};
var selectPriceMapByProcessingCode = function selectPriceMapByProcessingCode(processingCode) {
  return (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([selectPrices], function (prices) {
    return prices.filter(function (_ref5) {
      var option = _ref5.option;
      return option === processingCode;
    }).reduce(function (res, _ref6) {
      var code = _ref6.code.code,
          price = _ref6.price;
      res[code] = price;
      return res;
    }, {});
  });
};
var selectRushProcessingPriceByProcessingCode = function selectRushProcessingPriceByProcessingCode(processingCode) {
  return createSelector([selectPrices], function (prices) {
    var _prices$find;

    return ((_prices$find = prices.find(function (_ref7) {
      var option = _ref7.option,
          code = _ref7.code.code;
      return option === processingCode && code === PRODUCT_CODES.tmRushProcessing;
    })) === null || _prices$find === void 0 ? void 0 : _prices$find.price) || null;
  });
};
var selectFees = function selectFees(state) {
  return state.variants.fees.data;
};
var selectFeesError = function selectFeesError(state) {
  return state.variants.fees.error;
};
var selectFeesLoading = function selectFeesLoading(state) {
  return state.variants.fees.loading;
};
var selectFeeMapByProductCode = function selectFeeMapByProductCode(productCode) {
  return createSelector([selectFees], function (fees) {
    return fees.filter(function (_ref8) {
      var code = _ref8.code.code;
      return code === productCode;
    }).reduce(function (res, _ref9) {
      var option = _ref9.option,
          price = _ref9.price;
      res[option] = price;
      return res;
    }, {});
  });
};
var selectFeeMapByProcessingCode = function selectFeeMapByProcessingCode(processingCode) {
  return createSelector([selectFees], function (fees) {
    return fees.filter(function (_ref10) {
      var option = _ref10.option;
      return option === processingCode;
    }).reduce(function (res, _ref11) {
      var code = _ref11.code.code,
          price = _ref11.price;
      res[code] = price;
      return res;
    }, {});
  });
};
var selectUpsellOffers = function selectUpsellOffers(state) {
  return state.variants.upsellOffers.data;
};
var selectUpsellOffersError = function selectUpsellOffersError(state) {
  return state.variants.upsellOffers.error;
};
var selectUpsellOffersLoading = function selectUpsellOffersLoading(state) {
  return state.variants.upsellOffers.loading;
};
var selectAvailableUpsellProductCodes = function selectAvailableUpsellProductCodes(productCodesFromOrder) {
  return (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_1__/* .createSelector */ .P1)([selectUpsellOffers], function (upsellOffers) {
    return upsellOffers.filter(function (_ref12) {
      var finishedProduct = _ref12.finishedProduct,
          upsellOffer = _ref12.upsellOffer,
          disabled = _ref12.disabled;
      return (productCodesFromOrder === null || productCodesFromOrder === void 0 ? void 0 : productCodesFromOrder.includes(finishedProduct === null || finishedProduct === void 0 ? void 0 : finishedProduct.code)) && !(productCodesFromOrder !== null && productCodesFromOrder !== void 0 && productCodesFromOrder.includes(upsellOffer === null || upsellOffer === void 0 ? void 0 : upsellOffer.code)) && !disabled;
    }).map(function (_ref13) {
      var upsellOffer = _ref13.upsellOffer;
      return upsellOffer === null || upsellOffer === void 0 ? void 0 : upsellOffer.code;
    }).reduce(function (res, code) {
      if ([_constants_products__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_CODES.tmPrivacyPackage */ .P.tmPrivacyPackage, _constants_products__WEBPACK_IMPORTED_MODULE_0__/* .PRODUCT_CODES.tmPrivateContactInfo */ .P.tmPrivateContactInfo].includes(code)) {
        if (!res.includes(_constants_products__WEBPACK_IMPORTED_MODULE_0__/* .SYNTHETIC_PRODUCT_CODES.tmPrivacyComplex */ .E.tmPrivacyComplex)) {
          res.push(_constants_products__WEBPACK_IMPORTED_MODULE_0__/* .SYNTHETIC_PRODUCT_CODES.tmPrivacyComplex */ .E.tmPrivacyComplex);
        }

        return res;
      }

      res.push(code);
      return res;
    }, []);
  });
};
var selectFileTypes = function selectFileTypes(state) {
  return state.variants.fileTypes.data;
};
var selectFileTypesError = function selectFileTypesError(state) {
  return state.variants.fileTypes.error;
};
var selectFileTypesLoading = function selectFileTypesLoading(state) {
  return state.variants.fileTypes.loading;
};

/***/ })

}]);